export default __webpack_public_path__ + "static/media/text.90e5aaf9.svg";